const ColourPallette = {
    "NumberPatients": "#F3CAFF",
    "Number of Studies": "#D0FEF5",
    "Population": "#F0CF65",
    "Conditions": "#7dc4ff",
    "Intervention": "#ACDDE7",
    "Comparison": "#ADB9E3",
    "Outcome": "#F6F5AE",
    "Regulatory References": "#F7DBA7",
    "_summary_": "#e5d7f5",
    "_comparison_deleted_": "#FEE2E2",
    "_comparison_inserted_": "#D1FAE5",
    "_comparison_deleted_special_": "#FEE2E2", // sync with _comparison_deleted_
    "_comparison_inserted_special_": "#D1FAE5", // sync with _comparison_inserted_
}

const AnnotationsColorPalette = {
    "blue": "#e2f3ff",
    "green": "#e0ffe0",
    "yellow": "#fff9e2",
    "red": "#ffe8e8",

    "dark_blue": "#5cb9ff",
    "dark_green": "#55f255",
    "dark_yellow": "#ffcc01",
    "dark_red": "#f24646",
}

export { ColourPallette, AnnotationsColorPalette };